export enum EDevice {
    IPHONE = "iPhone",
    IPAD = "iPad",
    ANDROID_PHONE = "AndroidPhone",
    ANDROID_TABLET = "AndroidTablet",
    ALL_DEVICES = "Total",
    COMBINED = "Combined",
}

export interface IDeviceFilterItem {
    id: EDevice;
    text: string;
    icon: string;
}
